/* tslint:disable:max-line-length */
import {Component, OnInit,ChangeDetectorRef, OnDestroy} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ApiHelper} from './../../_helpers/api.helper';
import {CommonHelper} from './../../_helpers/common.helper';
import {ConstantHelper} from './../../_helpers/constant.helper';
import {AppConfig} from './../../../app/app.config';
import {UserService} from './../../_services/user.service';
import {SweetAlertHelper} from 'src/app/_helpers/sweet.alert.helper';
import {Message} from 'src/app/_locale/message';
import { Observable, of } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { map, switchMap } from 'rxjs/operators';
import { AiSummaryCommonHelper } from 'src/app/_helpers/aiSummary.common.helper';

@Component({
  selector: 'patient-history',
  templateUrl: './patient-history.component.html',
  styleUrls: ['./patient-history.component.scss'],
})
export class PatientHistory implements OnInit, OnDestroy {
  // private pdfApiUrl = 'https://app-dev-ashchatgpt.azurewebsites.net/reports';
  // private videoApiUrl = 'https://app-videosummerize-us.azurewebsites.net/analyze_video';
  // private imageApiUrl = 'https://app-videosummerize-us.azurewebsites.net/analyze_image';
  // private askAiApiUrl = "https://app-dev-ashchatgpt.azurewebsites.net/get_ai_res_summary";

  httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });
  httpOptions = {
    headers: this.httpHeaders,
  };
  childRoute: string;
  loggedInUserId: string;
  comapnyName: string = ConstantHelper.COMPANY_NAME;
  companySlug: string = ConstantHelper.COMPANY_SLUG;
  showDataVal: any;  
  loggedInUserRoleId = localStorage.getItem('loggedInUserRoleId');
  message = Message;
  showTableData = 1;
  showLoader = false;
  delegateId = localStorage.getItem('delegateId');
  dtOptions: DataTables.Settings = {};
  profileObj : any = {};
  documentsList : any = [];
  summaryPopup : any = false;
  patientDetails : any = [];
  patientId : string;
  bmi: any;
  patientsTreatingDoctorsList : any = [];
  patientsNonTreatingDoctorsList : any = [];
  documentsLength: any;
  resultJsonObj: any = {};
  selectedAiSummary: any = {};
  summaryAnswer: string;
  isSummaryAnswer: boolean = false;
  isAskSummaryAnswer: boolean = false;
  summaryAskAnswer: string;
  questionToSummary: string;
  confirmSummaryPopup: any = false;
  documentComment: string;
  documentCommentDetails: any[] = [];
  documentCommentDetailsLength: boolean = false;
  saveSummaryBtn: boolean = false;
  loggedInUserName: any;
  facilityDetailsArray : any;
  openFacilityDetailsPopup : boolean = false;
  practiceDocumentsFlag : boolean = false;
  practiceDocumentsList : any = [];
  dictationList: any = [];
  adminCommentsList: boolean = false;

  commentId: any;
  showShareSummaryModal: boolean = false;
  isSummarySigned: any = 0;
  isSummaryEdited: any = 0;
  showSignedAiSummaryModal: boolean = false;

  practices: any;
  physicians1: any;
  tempPhysician01: any = [];
  physicianInfo1: any = '';
  tempPractice01: any = [];
  practiceInfo1: any = '';
  finalPhysician01: any = [];
  selectedPhysiciansIdList: any = [];
  docUrl: SafeResourceUrl = '';
  isVideo: boolean = false;
  isSummaryInputVisible: boolean;
  addFileDescription: any;
  addFileContent: any;
  isSatisfied: false;
  showModificationFields :boolean;
  flag = 0;
  copyTooltip: string;
  copyText: string = "Copy";
  patientDemographicId: any;
  
  // Speech recognition properties
  isRecordingDescription: boolean = false;
  isRecordingContent: boolean = false;
  isRecordingQuestion: boolean = false;
  recognition: any;
  isSpeechSupported: boolean = false;
  savedAskSummary: string;
  savedAskQuestion: string;
  lastAskedQuestion: string;
  private isDestroyed: boolean = false;
  
  constructor(
    public commonHelper: CommonHelper,
    private appConfig: AppConfig,
    private activatedRoute: ActivatedRoute,
    public sweetAlertHelper: SweetAlertHelper,
    private router: Router,
    private http: HttpClient,
    public userService: UserService,
    private sanitizer: DomSanitizer,
    private aiSummaryCommonHelper: AiSummaryCommonHelper,
    private cdr: ChangeDetectorRef
  ) {
    localStorage.setItem('childRoute', activatedRoute.snapshot.url[0].path);
    this.childRoute = activatedRoute.snapshot.url[0].path;
    this.patientId = this.activatedRoute.snapshot.paramMap.get('demographyUserId');
  }

  ngOnInit() {
    this.showDataVal = this.activatedRoute.snapshot.paramMap.get('showDataVal');
    this.dtOptions = { order: [], pageLength: this.documentsLength};
    this.getPatientDetailsById()
    this.showData(this.showDataVal)

    
    
    this.patientDetails.BMI = this.BMI_calculator();
    this.bmi = this.BMI_calculator()

    this.fnFindAllDocuments('0');
    this.loggedInUserName = localStorage.getItem("loggedInUserName")
    this.getUserPractices()

    this.docUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');
    this.loggedInUserId = localStorage.getItem('loggedInUserId')
    
    // Initialize speech recognition
    this.initializeSpeechRecognition();
  }

  BMI_calculator(){
    const totalHeightInches = this.patientDetails.HeightInFeet * 12 + '.' + (this.patientDetails.HeightInInch ? this.patientDetails.HeightInInch : 0);
    let BMI = (this.patientDetails.Weight/(+totalHeightInches*+totalHeightInches)) * 703
    return parseFloat(BMI.toFixed(2));
  }

  

  
  showData(selectedVal) {
    this.showDataVal = selectedVal;
  }


  
  showD2DEmailRequest(value) {
    if (value == 1) {
      this.showTableData = value;
    } else if (value == 2) {
      this.showTableData = value;
    } else if (value == 3) {
      this.showTableData = value;
    }
  }

  openSummaryPopup(documentId){
    this.selectedAiSummary = this.documentsList.find(
      (e) => e.RecordId == documentId
    );
    this.summaryPopup = true;
  }

  openConfirmSummaryPopup(documentId){
    this.selectedAiSummary = this.documentsList.find(
      (e) => e.RecordId == documentId
      );
    this.confirmSummaryPopup = true;
  }

  openRejectSummaryPopup(documentId){
    this.selectedAiSummary = this.documentsList.find(
      (e) => e.RecordId == documentId
    );
  }

  closeSummaryPopup(){
    this.summaryPopup = false;  
    this.confirmSummaryPopup = false;
    this.documentComment = '';
    this.summaryAnswer = '';
    this.isSummaryAnswer = false;
    this.saveSummaryBtn = false;
    this.summaryAskAnswer = "";
    this.questionToSummary = "";
    this.isSummaryInputVisible = false;
  }


  async getPatientDetailsById() {
    this.patientDetails = [];
    const finalData = {
      patientId: this.patientId,
    };
    this.showLoader = true;

    this.http
      .post(this.appConfig.getLambdaUrl05() + ApiHelper.getPatientDetailsById, finalData, this.httpOptions)
      .subscribe(
        (res: any) => {
          if(res){
            this.patientDetails = res.commandResult.data.patientInfo;
            this.patientDemographicId = this.patientDetails.RecordId;
            this.showLoader = false;
          }
        },
        (err) => {
          this.showLoader = false;
        }
      );
  }

  async updatePatientDetailsByPhysician() {
    this.bmi = this.BMI_calculator();
    const finalData = {
      loggedInUserId: localStorage.getItem('loggedInUserId'),
      patientId: this.patientId,
      heightInFeet: this.patientDetails.HeightInFeet,
      heightInInch: this.patientDetails.HeightInInch,
      weight: this.patientDetails.Weight,
      bmi: this.bmi
    };
    this.showLoader = true;

    this.http
      .post(this.appConfig.getLambdaUrl05() + ApiHelper.updatePatientDetailsByPhysician, finalData, this.httpOptions)
      .subscribe(
        async (res: any) => {
          this.showLoader = false;
          window.location.reload();
        },
        (err) => {
          this.showLoader = false;
        }
      );
  }

  async goToDemographics() {
      this.router.navigate([
        "/" + this.childRoute + "/demographics/" + localStorage.getItem('loggedInUserId') + "/0"
      ]);
  }

  async onReset() {
      localStorage.removeItem("isDelegating");
      localStorage.removeItem("delegateId");
      this.router.navigate([
        "/" + this.childRoute + "/dashboard/" + localStorage.getItem('loggedInUserId'),
      ]);
  }

  
  async getPatientsTreatingDoctorsList() {
    this.documentsLength = 0;
    const finalData = {
      patientId: this.patientId,
      
    };
    this.showLoader = true;
    this.http
      .post(this.appConfig.getLambdaUrl05() + ApiHelper.getPatientsTreatingDoctorsList, finalData, this.httpOptions)
      .subscribe(
        async (res: any) => {
          this.showLoader = false;
          if (res.commandResult.data.doctorsList.length > 0){
            this.patientsTreatingDoctorsList = res.commandResult.data.doctorsList;
          }
        },
        (err) => {
          this.showLoader = false;
        }
      );
  }

  async getPatientsNonTreatingDoctorsList() {
    this.documentsLength = 0;
    const finalData = {
      patientId: this.patientId,
      
    };
    this.showLoader = true;
    this.http
      .post(this.appConfig.getLambdaUrl05() + ApiHelper.getPatientsNonTreatingDoctorsList, finalData, this.httpOptions)
      .subscribe(
        async (res: any) => {
          this.showLoader = false;
          if (res.commandResult.data.nonTreatingDoctorsList.length > 0){
            this.patientsNonTreatingDoctorsList = res.commandResult.data.nonTreatingDoctorsList;
          }
        },
        (err) => {
          this.showLoader = false;
        }
      );
  }

  fnFindAllDocuments(docType) {
    this.documentsLength = 0
    let finalData;
    if(localStorage.getItem("isDelegating") == '1'){
      finalData = {
        patientId: this.patientId,
        company_slug: ConstantHelper.COMPANY_SLUG,
        email: this.profileObj.Email,
        physicianId: localStorage.getItem("delegateId"),
        userRoleId: this.loggedInUserRoleId,
      };
    } else {
      finalData = {
        patientId: this.patientId,
        company_slug: ConstantHelper.COMPANY_SLUG,
        email: this.profileObj.Email,
        physicianId: localStorage.getItem("loggedInUserId"),
        userRoleId: this.loggedInUserRoleId,
      };
    }
    this.showLoader = true;

    this.http
    .post(
            this.appConfig.getPhpUrl() + ApiHelper.php_fetchAllDocumentsForPatientHistory,
            finalData,
            this.httpOptions
        )
        .subscribe(
            (apiResponse) => {
                this.resultJsonObj = apiResponse;
                if (this.resultJsonObj.commandResult.data.documentList.length > 0) {
                    if (docType != '0') {
                        this.documentsList = this.resultJsonObj.commandResult.data.documentList.filter(doc => doc.DocumentCategoryId == docType);
                        this.documentsLength = this.documentsList.length;
                    } else {
                        this.documentsList = this.resultJsonObj.commandResult.data.documentList;
                        this.documentsLength = this.documentsList.length;
                    }
                } else {
                    this.documentsLength = 0;
                }
                this.showLoader = false;
            },
            (err) => {}
        );
  }

  async askQuestion(){
    this.showLoader = true;
    const extension = await this.aiSummaryCommonHelper.checkDocumentType(this.selectedAiSummary.DocumentUrl);
    const question = this.questionToSummary;
    this.lastAskedQuestion = question;
    const prevSummary = this.selectedAiSummary.AiSummary;
    this.flag= 1;
    const askQueSummary = await this.aiSummaryCommonHelper.generateSummary(this.selectedAiSummary.DocumentUrl,question,prevSummary,extension,this.flag);
    this.isAskSummaryAnswer = true;
    this.summaryAskAnswer = askQueSummary;  
    this.questionToSummary = '';
    this.showLoader = false;  
  }

  async saveAskSummary() {
    try {
      const question = this.lastAskedQuestion || this.questionToSummary || '';
      const answer = this.summaryAskAnswer || '';

      // Get existing AiAskSummary text (if null/undefined, make it empty)
      let existingSummary = this.selectedAiSummary.AiAskSummary || '';

      // Append new Q&A in the desired format with bold text
      const newEntry = `\n<b>Question:</b> ${question}<br/><br/><b>Answer:</b> ${answer}<br/><hr style="border-bottom: 2px solid black; background-color: black; height: 2px;">`;
      existingSummary += newEntry;

      const finalData = {
        documentId: this.selectedAiSummary.RecordId,
        aiAskSummary: existingSummary
      };

      await this.http
        .post(
          this.appConfig.getLambdaUrl05() + ApiHelper.saveAiAskSummaryByClick,
          finalData,
          this.httpOptions
        )
        .toPromise();

      // Update local UI state
      this.selectedAiSummary.AiAskSummary = existingSummary;
      this.savedAskQuestion = question;
      this.savedAskSummary = answer;
      this.isAskSummaryAnswer = false;
      this.questionToSummary = '';

    } catch (err) {
      console.error(err);
    }
  }

  cancelSave() {
    this.isAskSummaryAnswer = false;
  }
  

  // async generateSummary(documentUrl: string, extension: string, summary:string): Promise<void> {
  //   return new Promise<void>(async (resolve, reject) => {
  //       this.showLoader = true;       
  //       const extension = await this.aiSummaryCommonHelper.checkDocumentType(this.selectedAiSummary.DocumentUrl);
  //       if(extension == "Video")
  //       {
  //         this.showLoader = false;
  //         this.isSummaryInputVisible = true; 
  //       }
  //       else
  //       {
  //         this.aiSummaryCommonHelper.summarizeReport(this.selectedAiSummary.DocumentUrl, extension,this.addFileDescription, this.addFileContent,this.flag).subscribe(
  //           (response) => {
  //               this.isSummaryAnswer = true;
  //               this.summaryAnswer = response.answer;
  //               const finalData = {
  //                 documentId: this.commentId,
  //                 aiSummary: this.summaryAnswer
  //               };
  //               this.selectedAiSummary.aiSummary = this.summaryAnswer;
  //               this.onSatisfactionResponse(true,finalData);                
  //               resolve();
  //               return this.selectedAiSummary;
  //           },
  //           (error) => {
  //               this.showLoader = false;
  //               reject(error);
  //           }
  //       );
  //       }       
  //   });
  // }

  async generateSummary(documentUrl: string, extension: string, summary:string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      // alert(this.selectedAiSummary.DocumentUrl)
        // this.showLoader = true;       
        // this.showLoader = false;
        this.isSummaryInputVisible = true;              
    });
  }
  
  async generateScreenCaptureSummary(documentUrl: string, addFileDescription:string,addFileContent:string ): Promise<void> {
    // let extension= "Video";  
    const extension = await this.aiSummaryCommonHelper.checkDocumentType(this.selectedAiSummary.DocumentUrl);  
    if(extension == "Video")
      {      
    if(!this.addFileDescription)
      {
        this.sweetAlertHelper.alertPopUp("Please Provide the video description and the content you are looking for")
        return;
      } 
      if(!this.addFileContent)
        {
          this.sweetAlertHelper.alertPopUp("Please Provide the content you are looking for")
          return;
        } 
      } 
    try{   
        this.showLoader = true;
        const generatedSummary = await this.aiSummaryCommonHelper.generateSummary(documentUrl,this.addFileDescription,this.addFileContent,extension,this.flag)
        this.summaryAnswer = generatedSummary;
        const finalData = {
          documentId: this.commentId,
          aiSummary: this.summaryAnswer
      };       
      const storeSummary = await this.onSatisfactionResponse(this.isSatisfied,finalData)       
      this.showLoader = false;
      this.isSummaryAnswer = true;
      this.isSummaryInputVisible = false; 
    }catch (error) {
      this.sweetAlertHelper.alertPopUp("An error occurred while generating the summary. Please try again.");
      this.showLoader = false;
  }
  }
  async onSatisfactionResponse(isSatisfied: any, finalData: { documentId: any; aiSummary: string; }) {
    if(isSatisfied)
    {
      await this.saveAiSummary()
    }
    else
    {
      this.isSummaryInputVisible = true;
      this.showModificationFields = true;      
    }
  }

  confirmOrObjectionSummary(action: string) {
    const activity = (action === 'confirmation') ? 'confirmation' : 'objection';
    const activityType = (action === 'confirmation') ? 1 : 0;

    const finalData = {
        documentId: +this.selectedAiSummary.RecordId,
        userId: localStorage.getItem("loggedInUserId"),
        activity: activity,
        documentComment: this.documentComment,
        activityType: activityType
    };
    this.showLoader = true;
    this.http
        .post(this.appConfig.getLambdaUrl05() + ApiHelper.documentConfirmObjectionPatientHistory, finalData, this.httpOptions)
        .subscribe(
            (apiResponse) => {
                this.showLoader = false;
                window.location.reload();
            },
            (err) => {}
        );
    this.closeSummaryPopup();
}


  getConfirmationObjectionComments(documentId){
    this.documentCommentDetails = [];
    const finalData = {
      userId: +this.loggedInUserId,
      documentId: +documentId
    };
    this.showLoader = true;

    this.http
      .post(this.appConfig.getLambdaUrl05() + ApiHelper.getDocumentConfirmObjectionPatientHistory, finalData, this.httpOptions)
      .subscribe(
        (res: any) => {
          if(res){
            if(res.commandResult.data.commentsInfo.length > 0){
              this.documentCommentDetails = res.commandResult.data.commentsInfo;
              this.showLoader = false;
              this.documentCommentDetailsLength = true
            } else {
              this.showLoader = false;
              this.documentCommentDetailsLength = false;
            }
          }
        },
        (err) => {
          this.showLoader = false;
        }
      );
  }


async saveAiSummary() {
  try {
      const finalData = {
          documentId: this.selectedAiSummary.RecordId,
          aiSummary: this.summaryAnswer
      };
      this.showLoader = true;
      await this.http.post(this.appConfig.getLambdaUrl05() + ApiHelper.generateAiSummaryByClick, finalData, this.httpOptions).toPromise();
      this.showLoader = false;
      window.location.reload();
  } catch (err) {
      console.error(err);
  }
}

closeFacilityDetailsPopup(){
  this.openFacilityDetailsPopup = false;
}

openFacilityDetailsPopupWindow(documentId){
  this.facilityDetailsArray = [this.documentsList.find(
    (e) => e.RecordId == documentId
    )];
  this.openFacilityDetailsPopup = true;
}

findPracticeDocuments(){
  this.documentsLength = 0;
  const finalData = {
    userId: this.patientId
  };
  this.showLoader = true;

  this.http
      .post(
          this.appConfig.getLambdaUrl05() + ApiHelper.findPracticeDocuments,
          finalData,
          this.httpOptions
      )
      .subscribe(
          (apiResponse: any) => {
            if(apiResponse.commandResult.data.docsList.length > 0){
              this.practiceDocumentsFlag = true;
              this.practiceDocumentsList = apiResponse.commandResult.data.docsList
            }
              this.showLoader = false;
          },
          (err) => {}
      );
}

async findDictations() {
  this.dictationList = [];
  const finalData = {
    userId: localStorage.getItem('loggedInUserId'),
    patientId: this.patientId,
    companySlug: ConstantHelper.COMPANY_SLUG,
  };
  this.showLoader = true;
  this.http
    .post(this.appConfig.getLambdaUrl05() + ApiHelper.findDictationFiles, finalData, this.httpOptions)
    .subscribe(
      (res: any) => {
        if(res.commandResult.data.Dictations.length > 0){
          this.dictationList = res.commandResult.data.Dictations.filter((item) => item.IsSummarySigned == 1);
          this.showLoader = false;
          this.adminCommentsList = true;
        }
      },
      (err) => {
        this.showLoader = false;
        console.error(err);
      }
    );
    this.showLoader = false;
}


openDictationSummary(SummaryUrl: string): void {
  if (SummaryUrl) {
    window.open(SummaryUrl, '_blank');
  } else {
    console.error('Summary URL is not available.');
  }
}

openMp3FIle(recordingUrl: string): void {
  if (recordingUrl) {
    window.open(recordingUrl, '_blank');
  } else {
    console.error('Recording URL is not available.');
  }
}

openTranscript(TranscriptUrl: string): void {
  if (TranscriptUrl) {
    window.open(TranscriptUrl, '_blank');
  } else {
    console.error('Transcript URL is not available.');
  }
}

setCommentId(commentId: any) {
  this.commentId = commentId
}

openShareSummaryModal() {
  this.showShareSummaryModal = true;
}


onChangePractice(companyUrl) {
  const reqData = {
    company_slug: companyUrl,
    loggedInUserId: this.patientId,
  };

  this.http
    .post(
      this.appConfig.getPhpUrl() + ApiHelper.php_findUserDoctorsByPracticeApi,
      reqData,
      this.httpOptions
    )
    .subscribe(
      (apiResponse: any) => {
          this.physicians1 = apiResponse.commandResult.data.companiesList;
      },
      (err) => {
      }
    );
}

getUserPractices() {
  const finalData = {
    loggedInUserId: this.patientId,
  };
  this.showLoader = true;
  this.http
    .post(
      this.appConfig.getPhpUrl() + ApiHelper.php_findUserPracticeApi,
      finalData,
      this.httpOptions
    )
    .subscribe(
      (apiResponse: any) => {
        this.practices = apiResponse.commandResult.data.companiesList;
        this.showLoader = false;
      },
      (err) => {
        console.error(err);
      }
    );
}


async listData() {
  if (this.physicianInfo1.length <= 0) {
    await this.sweetAlertHelper.alertPopUp('Please select practice or physician');
    return false;
  }
    if (this.physicianInfo1 == 'all') {
      this.tempPractice01.push(
        this.practices.find((x) => x.company_url == this.practiceInfo1)
      );
    } else {
      this.physicianInfo1.forEach((element) => {
        const existingPhysician = this.finalPhysician01.find((x) => x.physician_id == element);
        if (!existingPhysician) {
          const selectedPhysician = this.physicians1.find((x) => x.physician_id == element);
          if (selectedPhysician) {
            this.finalPhysician01.push(selectedPhysician);
            this.tempPhysician01.push(selectedPhysician);

            this.selectedPhysiciansIdList.push(selectedPhysician.physician_id);
          }
        }
      });
  }
}

onChangePhysician(value, j) {
  if (value == 'all' && j == 0) {}
  if (value == 'all' && j == 1) {}
  if (value == 'all' && j == 2) {}
  if (value == 'all' && j == 3) {}
  if (value == 'all' && j == 4) {}
}

closeEditModal() {
 
  this.showShareSummaryModal = false;
  this.showSignedAiSummaryModal = false;
  this.isVideo = false;
}

shareSummaryWithPhysician(){

  const finalData = {
    patientId: this.patientId,
    sendingPhysicianId: localStorage.getItem('loggedInUserId'),
    receivingPhysicianId: this.selectedPhysiciansIdList,
    dictationSummaryId: this.commentId,
  };
  this.showLoader = true;
  this.http
    .post(
      this.appConfig.getLambdaUrl05() + ApiHelper.postPhysicianSharedDictationSummary,
      finalData,
      this.httpOptions
    )
    .subscribe(
      (apiResponse: any) => {
        if(apiResponse.commandResult.status == 1){
          this.showShareSummaryModal = false;
          this.selectedPhysiciansIdList = []
        }
        this.showLoader = false;
      },
      (err) => {}
    );
}


async goToUserComments() {
  this.router.navigate(['/' + this.childRoute + '/comments/' + localStorage.getItem("loggedInUserId") + '/' + this.patientId,]);
}

async goToUserVisit() {
  this.router.navigate(['/' + this.childRoute + '/admin-practice-dictation/' + localStorage.getItem("loggedInUserId") + '/' + this.patientId,]);
}

async goToUserEmailLog() {
    this.router.navigate(['/' + this.childRoute + '/email-logs/' + localStorage.getItem("loggedInUserId") + '/' + this.patientId,]);
}

async goToUserDocGroup() {
  const alertStatus = await this.sweetAlertHelper.confirmPopUp(
    this.message.confirmTitle,
    this.message.confirmMessages.demographicsComp.goToUserDocGoupComp
  );
  if (alertStatus) {
    this.router.navigate(['/' + this.childRoute + '/assign-doc-group/' + localStorage.getItem("loggedInUserId") + '/' + this.patientId + '/' + this.patientDemographicId,]);
  }
}

async goToUHF() {
  const alertStatus = await this.sweetAlertHelper.confirmPopUp(
    this.message.confirmTitle,
    this.message.confirmMessages.demographicsComp.goToUHF
  );
  if (alertStatus) {
    this.router.navigate(['/' + this.childRoute + '/ushf/' + localStorage.getItem("loggedInUserId") + '/' + this.patientId + '/' + this.patientDemographicId,]);
  }
}

async goToShareDocument() {
  const alertStatus = await this.sweetAlertHelper.confirmPopUp(
    this.message.confirmTitle,
    this.message.confirmMessages.demographicsComp.goToDocumentUpload
  );
  if (alertStatus) {
    this.router.navigate(['/' + this.childRoute + '/upload-document/' + localStorage.getItem("loggedInUserId") + '/' + this.patientId + '/' + this.patientDemographicId,]);
  }
}

async goTo2ndopinionWF() {
    this.router.navigate(['/' + this.childRoute + '/second-opinion-wf/' + localStorage.getItem("loggedInUserId") + '/' + this.patientId + '/' + 1]);
}

async goToPatientEmail() {
    this.router.navigate(['/' + this.childRoute + '/email2user/' + localStorage.getItem("loggedInUserId") + '/' + this.patientId]);
}


checkAndShowDocument(url: string, event: Event): void {
  const fileExtension = url.split('.').pop().toLowerCase();
  if (fileExtension === 'mp4') {
    event.preventDefault();
    this.showDocument(url);
  }
}

showDocument(documentUrl: any) {
  var selectedFileExt = ''
  selectedFileExt = this.getFileExtension(documentUrl).toLowerCase();
  if (selectedFileExt == "mp4") {
    this.docUrl = this.sanitizer.bypassSecurityTrustResourceUrl(documentUrl);
    this.isVideo = true;
  }else {
    this.docUrl = this.sanitizer.bypassSecurityTrustResourceUrl(documentUrl);
  }
}

getFileExtension(filename) {
  const extension = filename.split(".").pop();
  return extension;
}

closeVideoModal(){
  this.isVideo = false;
}

copyAiSummary(text: string) {
  let fullText = '';
  
  // Add AI Summary if available
  if (this.selectedAiSummary.AiSummary) {
    fullText += this.selectedAiSummary.AiSummary;
  }
  
  // Add AI Ask Summary if available
  if (this.selectedAiSummary.AiAskSummary) {
    if (fullText) {
      fullText += '\n\n'; // Add spacing between sections
    }
    fullText += this.selectedAiSummary.AiAskSummary;
  }
  
  // Add disclaimer at the end
  if (fullText) {
    fullText += '\n\n---\nDisclaimer: Clinical correlation is required. This is an AI-generated summary. Please review and verify all information for accuracy and completeness before making any clinical decisions.';
  }
  
  if (fullText) {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = fullText; // Assign the HTML content
    const plainText = tempElement.textContent || tempElement.innerText || "";
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = plainText; 
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand('copy');
    document.body.removeChild(tempTextArea);
    this.copyTooltip = "Copied Summary";
    this.copyText = "Copied";
    setTimeout(() => {
      this.copyTooltip = "Copy Summary";
      this.copyText = "Copy";
    }, 2000);
  }
}
clearfileds(){
  this.addFileContent = "";
  this.addFileDescription  = "";
  // Stop any ongoing recording
  this.stopRecording();
}

async goToUserRadiology() {
  sessionStorage.setItem("formId", this.patientDemographicId);
  sessionStorage.setItem("patientId", this.patientId);
  this.router.navigate(['/' + this.childRoute + '/admin-radiology/' + localStorage.getItem("loggedInUserId") + '/' + this.patientId,]);
}

// Initialize speech recognition
initializeSpeechRecognition() {
  if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
    this.isSpeechSupported = true;
    const SpeechRecognition = (window as any)['SpeechRecognition'] || (window as any)['webkitSpeechRecognition'];
    this.recognition = new SpeechRecognition();
    this.recognition.continuous = false;
    this.recognition.interimResults = false;
    this.recognition.lang = 'en-US';
  } else {
    this.isSpeechSupported = false;
    console.warn('Speech recognition not supported in this browser');
  }
}

// Start recording for description field
startRecordingDescription() {
  if (!this.isSpeechSupported) {
    this.sweetAlertHelper.alertPopUp('Speech recognition is not supported in your browser');
    return;
  }

  // If already recording, stop it
  if (this.isRecordingDescription) {
    this.stopRecording();
    return;
  }

  this.isRecordingDescription = true;
  this.recognition.continuous = true; // Enable continuous recording
  this.recognition.interimResults = true; // Enable interim results for better UX
  
  this.recognition.onstart = () => {
    console.log('Speech recognition started for description');
  };

  this.recognition.onresult = (event: any) => {
    // Get the final transcript from the last result
    const finalResult = event.results[event.results.length - 1];
    if (finalResult.isFinal) {
      const transcript = finalResult[0].transcript;
      // Append to existing text if there's already content, otherwise replace
      this.addFileDescription = this.addFileDescription ? this.addFileDescription + ' ' + transcript : transcript;
      if (!this.isDestroyed) {
        this.cdr.detectChanges();
      }
    }
  };

  this.recognition.onerror = (event: any) => {
    console.error('Speech recognition error:', event.error);
    this.isRecordingDescription = false;
    this.sweetAlertHelper.alertPopUp('Speech recognition error: ' + event.error);
    if (!this.isDestroyed) {
      this.cdr.detectChanges();
    }
  };

  this.recognition.onend = () => {
    // Only restart if user didn't manually stop it and there are no errors
    if (this.isRecordingDescription && this.recognition && !this.recognition.error) {
      // Add a small delay before restarting to avoid immediate restart loops
      setTimeout(() => {
        if (this.isRecordingDescription && this.recognition && !this.isDestroyed) {
          try {
            this.recognition.start();
          } catch (error) {
            console.log('Speech recognition restart failed:', error);
            this.isRecordingDescription = false;
          }
        }
      }, 100);
    }
    if (!this.isDestroyed) {
      this.cdr.detectChanges();
    }
  };

  this.recognition.start();
}

// Start recording for content field
startRecordingContent() {
  if (!this.isSpeechSupported) {
    this.sweetAlertHelper.alertPopUp('Speech recognition is not supported in your browser');
    return;
  }

  // If already recording, stop it
  if (this.isRecordingContent) {
    this.stopRecording();
    return;
  }

  this.isRecordingContent = true;
  this.recognition.continuous = true; // Enable continuous recording
  this.recognition.interimResults = true; // Enable interim results for better UX
  
  this.recognition.onstart = () => {
    console.log('Speech recognition started for content');
  };

  this.recognition.onresult = (event: any) => {
    // Get the final transcript from the last result
    const finalResult = event.results[event.results.length - 1];
    if (finalResult.isFinal) {
      const transcript = finalResult[0].transcript;
      // Append to existing text if there's already content, otherwise replace
      this.addFileContent = this.addFileContent ? this.addFileContent + ' ' + transcript : transcript;
      if (!this.isDestroyed) {
        this.cdr.detectChanges();
      }
    }
  };

  this.recognition.onerror = (event: any) => {
    console.error('Speech recognition error:', event.error);
    this.isRecordingContent = false;
    this.sweetAlertHelper.alertPopUp('Speech recognition error: ' + event.error);
    if (!this.isDestroyed) {
      this.cdr.detectChanges();
    }
  };

  this.recognition.onend = () => {
    // Only restart if user didn't manually stop it and there are no errors
    if (this.isRecordingContent && this.recognition && !this.recognition.error) {
      // Add a small delay before restarting to avoid immediate restart loops
      setTimeout(() => {
        if (this.isRecordingContent && this.recognition && !this.isDestroyed) {
          try {
            this.recognition.start();
          } catch (error) {
            console.log('Speech recognition restart failed:', error);
            this.isRecordingContent = false;
          }
        }
      }, 100);
    }
    if (!this.isDestroyed) {
      this.cdr.detectChanges();
    }
  };

  this.recognition.start();
}

// Start recording for question field
startRecordingQuestion() {
  if (!this.isSpeechSupported) {
    this.sweetAlertHelper.alertPopUp('Speech recognition is not supported in your browser');
    return;
  }

  // If already recording, stop it
  if (this.isRecordingQuestion) {
    this.stopRecording();
    return;
  }

  this.isRecordingQuestion = true;
  this.recognition.continuous = true; // Enable continuous recording
  this.recognition.interimResults = true; // Enable interim results for better UX
  
  this.recognition.onstart = () => {
    console.log('Speech recognition started for question');
  };

  this.recognition.onresult = (event: any) => {
    // Get the final transcript from the last result
    const finalResult = event.results[event.results.length - 1];
    if (finalResult.isFinal) {
      const transcript = finalResult[0].transcript;
      // Set the question text
      this.questionToSummary = transcript;
      if (!this.isDestroyed) {
        this.cdr.detectChanges();
      }
    }
  };

  this.recognition.onerror = (event: any) => {
    console.error('Speech recognition error:', event.error);
    this.isRecordingQuestion = false;
    this.sweetAlertHelper.alertPopUp('Speech recognition error: ' + event.error);
    if (!this.isDestroyed) {
      this.cdr.detectChanges();
    }
  };

  this.recognition.onend = () => {
    // Only restart if user didn't manually stop it and there are no errors
    if (this.isRecordingQuestion && this.recognition && !this.recognition.error) {
      // Add a small delay before restarting to avoid immediate restart loops
      setTimeout(() => {
        if (this.isRecordingQuestion && this.recognition && !this.isDestroyed) {
          try {
            this.recognition.start();
          } catch (error) {
            console.log('Speech recognition restart failed:', error);
            this.isRecordingQuestion = false;
          }
        }
      }, 100);
    }
    if (!this.isDestroyed) {
      this.cdr.detectChanges();
    }
  };

  this.recognition.start();
}

// Stop recording
stopRecording() {
  if (this.recognition) {
    this.recognition.stop();
    this.isRecordingDescription = false;
    this.isRecordingContent = false;
    this.isRecordingQuestion = false;
    
    // Only call detectChanges if the component is not being destroyed
    if (!this.isDestroyed) {
      this.cdr.detectChanges();
    }
  }
}

// Clean up speech recognition on component destruction
ngOnDestroy() {
  this.isDestroyed = true;
  this.stopRecording();
  if (this.recognition) {
    this.recognition.abort();
  }
}
  
}